export default "__VITE_ASSET__jE$tCkWF__"